// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { assignCaseSummarySelectedTerrCaseIds } from 'redux/modules/interferenceAnalysis'

const toggleTerrCaseIdSelect = terrCaseId => (dispatch, getState) => {
  const prevSelectedTerrCaseIds = getState().interferenceAnalysis.getIn(['caseSummary', 'selectedTerrCaseIds'])

  // look for the index of this terrCaseId in the current list of selectedTerrCaseIds
  const indexInSelected = prevSelectedTerrCaseIds.indexOf(terrCaseId)

  // if the segmentEndId wasn't in the list, then add it
  // otherwise remove the thing
  const selectedTerrCaseIds = (
    indexInSelected === -1
      ? prevSelectedTerrCaseIds.push(terrCaseId)
      : prevSelectedTerrCaseIds.remove(indexInSelected)
  )

  dispatch(assignCaseSummarySelectedTerrCaseIds(selectedTerrCaseIds))
}

export default toggleTerrCaseIdSelect
